module.exports = __webpack_public_path__ + "img/giams-colored.fa16b633.png";